module.exports = __webpack_public_path__ + "img/skinCare.c23d4543.svg";